export const dioroomTerms = {
  pt: {
    title: "Termos e Condições da Recompensa de Pré-Cadastro do Dioroom",
    lastUpdate: "Última atualização",
    updateDate: "09/06/2026",

    introduction: "Introdução",
    introductionContent:
     "Estes Termos e Condições regem a participação na campanha de pré-cadastro do jogo Dioroom e a concessão das recompensas promocionais oferecidas aos usuários elegíveis.", 

    rewardDescription: "Descrição da Recompensa",
    rewardDescriptionContent:
      "A recompensa de pré-cadastro consiste no desbloqueio gratuito do Mundo 1 dentro do Dioroom. Este conteúdo possui valor comercial aproximado de US$ 0,49 (USD) ou R$ 0,99 (BRL). Os preços podem variar de acordo com a moeda local, região, impostos aplicáveis, políticas da plataforma e futuras alterações de preço realizadas pela equipe do Dioroom.",

    eligibility: "Elegibilidade",
    eligibilityContent:
      "A recompensa está disponível apenas para usuários elegíveis que realizarem o resgate durante o período promocional definido pela equipe do Dioroom.",

    license: "Licença e Restrições",
    licenseContent:
      "O conteúdo desbloqueado é licenciado apenas para uso pessoal dentro do Dioroom. A recompensa não pode ser convertida em dinheiro, transferida para outras contas, revendida ou trocada por outros benefícios. O resgate é limitado a uma única vez por conta.",

    fraud: "Fraude e Uso Indevido",
    fraudContent:
      "O Dioroom reserva-se o direito de revogar a recompensa caso sejam identificadas tentativas de fraude, exploração de falhas, abuso de sistemas promocionais ou qualquer violação das regras do aplicativo.",

    availability: "Disponibilidade do Serviço",
    availabilityContent:
      "Embora nos esforcemos para manter o serviço disponível continuamente, o Dioroom não garante acesso ininterrupto ao aplicativo ou a conteúdos específicos devido a manutenções, problemas técnicos ou circunstâncias fora de nosso controle.",

    changes: "Alterações nos Termos",
    changesContent:
      "O Dioroom poderá modificar, suspender ou encerrar esta promoção a qualquer momento. Quaisquer alterações entrarão em vigor após sua publicação.",

    contact: "Contato",
    contactContent:
      "Caso tenha dúvidas sobre estes Termos e Condições, entre em contato com nossa equipe de suporte através do e-mail: blackpaladinsgames@gmail.com",

    acceptance: "Aceitação",
    acceptanceContent:
       'Ao realizar o pré-cadastro no Dioroom, você confirma que leu, compreendeu e concorda com estes Termos e Condições. Caso seja elegível para a promoção, o desbloqueio gratuito do Mundo 1 será concedido à sua conta quando a recompensa de pré-cadastro for disponibilizada.'
  },

  en: {
    title: "Dioroom Pre-Registration Reward Terms and Conditions",
    lastUpdate: "Last Update",
    updateDate: "06/09/2026",

    introduction: "Introduction",
    introductionContent:
      "These Terms and Conditions govern participation in the Dioroom pre-registration campaign and the granting of promotional rewards to eligible users.",

    rewardDescription: "Reward Description",
    rewardDescriptionContent:
       "The pre-registration reward consists of the free unlock of World 1 within Dioroom. This content has an approximate retail value of US$0.49 (USD) or R$0.99 (BRL). Prices may vary depending on local currency, region, applicable taxes, platform policies, and future pricing changes made by the Dioroom team.",

    eligibility: "Eligibility",
    eligibilityContent:
      "The reward is available only to eligible users who redeem it during the promotional period established by the Dioroom team.",

    license: "License and Restrictions",
    licenseContent:
      "The unlocked content is licensed for personal use only within Dioroom. The reward cannot be exchanged for money, transferred to another account, resold, or traded for other benefits. Redemption is limited to one per account.",

    fraud: "Fraud and Misuse",
    fraudContent:
      "Dioroom reserves the right to revoke the reward if fraudulent activity, exploitation of bugs, abuse of promotional systems, or violations of the application's rules are detected.",

    availability: "Service Availability",
    availabilityContent:
      "While we strive to keep the service continuously available, Dioroom does not guarantee uninterrupted access to the application or specific content due to maintenance, technical issues, or circumstances beyond our control.",

    changes: "Changes to These Terms",
    changesContent:
      "Dioroom may modify, suspend, or terminate this promotion at any time. Any changes will become effective upon publication.",

    contact: "Contact",
    contactContent:
      "If you have any questions regarding these Terms and Conditions, please contact our support team at: blackpaladinsgames@gmail.com",

    acceptance: "Acceptance",
    acceptanceContent:
      'By pre-registering for Dioroom, you confirm that you have read, understood, and agree to these Terms and Conditions. If you are eligible for the promotion, the free unlock of World 1 will be granted to your account when the pre-registration reward becomes available.'
  }
}